<template>
  <div class="add-funds">
    <img :src="img" alt="" class="logo">
    <h2>Add funds</h2>

    <div class="options">
      <CustomSelector v-model="account" placeholder="Trading account" :options="accounts"></CustomSelector>
      <CustomSelector v-model="currency" placeholder="Currency" :options="currencies"></CustomSelector>

      <input class="cabinet-input" type="text" placeholder="Amount (Min. 100 USD - max. 10,000 USD)" v-model="amount">

      <p class="disclaimer">Payments are only accepted from an account/card registered in your name. Please note that we
        may request additional documents and/or information for verification purposes.</p>
    </div>

    <button class="red-button" @click="transfer">Fund</button>

    <button class="cabinet-back" @click="back">
      <div class="icon"></div>
      Back
    </button>
  </div>
</template>

<script>
import CustomSelector from "@/components/CustomSelector";

export default {
  name: "AddFunds",
  components: {
    CustomSelector
  },
  created() {
    console.log(this.$route.params.target)

    window.addEventListener('keydown', this.reset);

    switch (this.$route.params.target) {
      case 'SKRILL':
        this.img = '/assets/images/logo_skrill.svg';
        break
      case 'NETELLER':
        this.img = '/assets/images/logo_neteller.svg';
        break
      case 'BITWALLET':
        this.img = '/assets/images/logo_bit_wallet.svg';
        break
      case 'ECOPAYZ':
        this.img = '/assets/images/logo_ecopayz.svg';
        break
      case 'TRONIPAY':
        this.img = '/assets/images/logo_tronipay.svg';
        break
      case 'UPHOLD':
        this.img = '/assets/images/logo_uphold.svg';
        break
      case 'BITPAY':
        this.img = '/assets/images/logo_bitpay.svg';
        break
      case 'PAYR':
        this.img = '/assets/images/logo_payretailers.svg';
        break
      case 'STICPAY':
        this.img = '/assets/images/logo_sticpay.svg';
        break
      case 'FASAPAY':
        this.img = '/assets/images/logo_fasapay.svg';
        break
      case 'ADVCASH':
        this.img = '/assets/images/logo_advcash.svg';
        break
      case 'TRANSFERMATE':
        this.img = '/assets/images/logo_transfermate.svg';
        break
      case 'PAYTRUST':
        this.img = '/assets/images/logo_paytrust.svg';
        break
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.reset);
  },
  data() {

    return {
      img: null,
      account: null,
      accounts: [],
      currency: null,
      currencies: [],
      amount: null,
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    reset(e) {
      if (e.key === 'Escape') {
        this.account = null;
        this.currency = null;
        this.amount = null;
      }
    },
    transfer() {
      console.log('transfer')
    }
  }
}
</script>

<style scoped>

</style>
